import { useEffect, useState } from "react";
import { Sun, CalendarDays, Users, FileText, HardHat, Wallet, Mail, Sparkles } from "lucide-react";
import api from "@/lib/api";

const pl = (n, one, many) => `${n ?? 0} ${n === 1 ? one : many}`;

const mailText = (s, mail) => [
  mail?.configured === false ? "Email da collegare" : mail?.count != null ? pl(mail.count, "email non letta", "email non lette") : "Email",
  s.whatsapp_non_letti ? `${s.whatsapp_non_letti} WhatsApp` : "",
].filter(Boolean).join(" · ");

// full = solo app completa · simpleOnly = solo gestionale semplice
export const TILES = [
  { key: "attivita", to: "/attivita-oggi", title: "Attività del giorno", icon: Sun, admin: true, featured: true,
    desc: "Il report dell'assistente IA: impegni, scadenze, cantieri, pagamenti ed email",
    simpleDesc: "Il report dell'assistente IA: appuntamenti, promemoria, pagamenti, email e WhatsApp",
    tone: "bg-gradient-to-br from-amber-200 via-amber-100 to-orange-100 border-amber-400 text-amber-950 dark:from-amber-900/70 dark:via-amber-900/40 dark:to-slate-900 dark:border-amber-700 dark:text-amber-50",
    iconBg: "bg-amber-500", count: (s) => (s.briefing_oggi ? "Report di oggi pronto" : "Tocca per preparare il report di oggi") },
  { key: "agenda", to: "/agenda", title: "Agenda e scadenze", icon: CalendarDays,
    tone: "bg-sky-100 border-sky-300 text-sky-950 dark:bg-sky-900/50 dark:border-sky-800 dark:text-sky-50", iconBg: "bg-sky-500",
    count: (s) => pl(s.appuntamenti_oggi, "appuntamento oggi", "appuntamenti oggi") + (s.scadenze_preventivi ? ` · ${pl(s.scadenze_preventivi, "scadenza", "scadenze")}` : "") },
  { key: "rubrica", to: "/contatti", title: "Rubrica clienti", icon: Users,
    tone: "bg-emerald-100 border-emerald-300 text-emerald-950 dark:bg-emerald-900/50 dark:border-emerald-800 dark:text-emerald-50", iconBg: "bg-emerald-500",
    count: (s) => pl(s.contatti, "contatto", "contatti") },
  { key: "documenti", to: "/preventivi", title: "Preventivi e fatture", icon: FileText, full: true,
    tone: "bg-indigo-100 border-indigo-300 text-indigo-950 dark:bg-indigo-900/50 dark:border-indigo-800 dark:text-indigo-50", iconBg: "bg-indigo-500",
    subs: [{ label: "Preventivi", to: "/preventivi" }, { label: "Fatture", to: "/fatture", admin: true }, { label: "DDT", to: "/ddt" }],
    count: (s) => pl(s.preventivi_aperti, "preventivo aperto", "preventivi aperti") },
  { key: "cantieri", to: "/cantieri", title: "Cantieri", icon: HardHat, admin: true, full: true,
    tone: "bg-orange-100 border-orange-300 text-orange-950 dark:bg-orange-900/50 dark:border-orange-800 dark:text-orange-50", iconBg: "bg-orange-500",
    subs: [{ label: "Cantieri", to: "/cantieri" }, { label: "Operai", to: "/cantieri?tab=operai" }],
    count: (s) => `${s.cantieri_attivi ?? 0} attivi · ${s.cantieri_in_partenza ?? 0} in partenza` },
  { key: "incassi", to: "/pagamenti-incassi", title: "Pagamenti e incassi", icon: Wallet, admin: true, full: true,
    tone: "bg-rose-100 border-rose-300 text-rose-950 dark:bg-rose-900/50 dark:border-rose-800 dark:text-rose-50", iconBg: "bg-red-500",
    subs: [{ label: "Pagamenti", to: "/pagamenti-incassi" }, { label: "Spese", to: "/spese" }],
    count: (s) => (s.pagamenti_scaduti ? pl(s.pagamenti_scaduti, "pagamento scaduto", "pagamenti scaduti") : pl(s.pagamenti_oggi, "pagamento oggi", "pagamenti oggi")),
    alert: (s) => (s.pagamenti_scaduti || 0) + (s.pagamenti_oggi || 0) > 0 },
  { key: "posta", to: "/posta", title: "Posta e WhatsApp", icon: Mail, admin: true,
    tone: "bg-teal-100 border-teal-300 text-teal-950 dark:bg-teal-900/50 dark:border-teal-800 dark:text-teal-50", iconBg: "bg-teal-500",
    subs: [{ label: "Posta", to: "/posta" }, { label: "WhatsApp", to: "/whatsapp" }], count: mailText },
  { key: "assistente", to: "/assistente", title: "Assistente IA", icon: Sparkles, admin: true, simpleOnly: true,
    tone: "bg-orange-100 border-orange-300 text-orange-950 dark:bg-orange-900/50 dark:border-orange-800 dark:text-orange-50",
    iconBg: "bg-gradient-to-br from-primary to-orange-400", count: () => "Scrivi o parla: agenda, pagamenti, email e clienti" },
];

export const visibleTiles = (isAdmin, simple = false) => TILES
  .filter((t) => (isAdmin || !t.admin) && (simple ? !t.full : !t.simpleOnly))
  .map((t) => ({ ...t, subs: (t.subs || []).filter((x) => isAdmin || !x.admin) }));

export const useHomeSummary = (isAdmin, simple = false) => {
  const [s, setS] = useState({});
  const [mail, setMail] = useState(null);
  useEffect(() => {
    api.get("/home/summary").then((r) => setS(r.data)).catch(() => {});
    if (isAdmin) api.get("/mail/unread").then((r) => setMail(r.data)).catch(() => {});
  }, [isAdmin, simple]);
  return { s, mail };
};
